(function () {
  'use strict';

  function formatBRLFromCents(cents) {
    var v = (Number(cents || 0) / 100);
    return v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  function calcPixCents(priceCents, percent) {
    var factor = 100 - Number(percent || 0);
    return Math.round((Number(priceCents || 0) * factor) / 100);
  }

  function safeJSONParse(txt) {
    try { return JSON.parse(txt); } catch (e) { return null; }
  }

  
  function findClosestProductForm(pixEl) {
    
    var node = pixEl;
    for (var i = 0; i < 10 && node; i++) {
      if (node.querySelector) {
        var f = node.querySelector('form[action^="/cart/add"]');
        if (f) return f;
      }
      node = node.parentNode;
    }
    
    return document.querySelector('form[action^="/cart/add"]');
  }

  function getSelectedOptionsFromForm(formEl, productJson) {
    if (!formEl || !productJson) return [];

    
    var optionCount = 0;
    if (productJson.options && Array.isArray(productJson.options)) {
      optionCount = productJson.options.length;
    } else {
      
      var v0 = (productJson.variants && productJson.variants[0]) || {};
      optionCount = (v0.option3 ? 3 : (v0.option2 ? 2 : 1));
    }

    var selected = new Array(optionCount).fill('');

    
    var selects = formEl.querySelectorAll('select[name^="options"], select[data-option]');
    if (selects && selects.length) {
      for (var i = 0; i < selects.length; i++) {
        var sel = selects[i];
        var idx = -1;

      
        idx = i;

        if (idx >= 0 && idx < optionCount) {
          selected[idx] = sel.value || '';
        }
      }
    }

    for (var j = 0; j < optionCount; j++) {
      if (selected[j]) continue;

      var radios = formEl.querySelectorAll('input[type="radio"][name^="options"]:checked, input[type="checkbox"][name^="options"]:checked');
      if (radios && radios.length) {
       
        selected = [];
        for (var r = 0; r < radios.length; r++) selected.push(radios[r].value || '');
        
        while (selected.length < optionCount) selected.push('');
        selected = selected.slice(0, optionCount);
        break;
      }
    }

    
    return selected;
  }

  function findVariantByOptions(productJson, selectedOptions) {
    if (!productJson || !Array.isArray(productJson.variants)) return null;

   
    var hasAny = selectedOptions && selectedOptions.some(function (v) { return !!v; });
    if (!hasAny) return null;

    for (var i = 0; i < productJson.variants.length; i++) {
      var v = productJson.variants[i];

      var ok1 = !selectedOptions[0] || String(v.option1) === String(selectedOptions[0]);
      var ok2 = !selectedOptions[1] || String(v.option2) === String(selectedOptions[1]);
      var ok3 = !selectedOptions[2] || String(v.option3) === String(selectedOptions[2]);

      if (ok1 && ok2 && ok3) return v;
    }

    return null;
  }

  function findVariantByHiddenId(formEl, productJson) {
    if (!formEl || !productJson || !Array.isArray(productJson.variants)) return null;

    var idInput = formEl.querySelector('input[name="id"]');
    if (!idInput || !idInput.value) return null;

    var vid = String(idInput.value);
    for (var i = 0; i < productJson.variants.length; i++) {
      if (String(productJson.variants[i].id) === vid) return productJson.variants[i];
    }
    return null;
  }

  function setPixPrice(pixEl, variant) {
    if (!pixEl || !variant || typeof variant.price === 'undefined') return;

    var percent = Number(pixEl.getAttribute('data-percent') || 0);
    var pixCents = calcPixCents(variant.price, percent);

    pixEl.innerHTML =
      formatBRLFromCents(pixCents) +
      ' <span>no Pix (' + percent + '% OFF)</span>';

    pixEl.setAttribute('data-variant-id', String(variant.id || ''));
  }

  function boot() {
    var pixEl = document.getElementById('pricePixOnly');
    if (!pixEl) return;

    var jsonEl = document.getElementById('PixProductJson');
    if (!jsonEl) return;

    var productJson = safeJSONParse(jsonEl.textContent || '');
    if (!productJson || !Array.isArray(productJson.variants)) return;

    var formEl = findClosestProductForm(pixEl);

    function update() {
      
      var vById = findVariantByHiddenId(formEl, productJson);
      if (vById) {
        setPixPrice(pixEl, vById);
        return;
      }

      
      var selected = getSelectedOptionsFromForm(formEl, productJson);
      var vByOpts = findVariantByOptions(productJson, selected);
      if (vByOpts) {
        setPixPrice(pixEl, vByOpts);
      }
    }

    
    update();

    
    if (formEl) {
      formEl.addEventListener('change', function () {
        
        setTimeout(update, 0);
      });

      formEl.addEventListener('input', function () {
        setTimeout(update, 0);
      });
    }

   
    var lastVariantId = pixEl.getAttribute('data-variant-id') || '';
    setInterval(function () {
      var currentId = pixEl.getAttribute('data-variant-id') || '';
      if (currentId !== lastVariantId) lastVariantId = currentId;

   
      update();
    }, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
